import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hardwareVersion',
})
export class FormatHardwareVersionPipe implements PipeTransform {

    transform(version: string) {

        if (!version) {
            return '';
        }

        let str = '' + version;
        version = 'v';

        while (str.length < 4) {
            str = '0' + str;
        }

        // if string is longer than 4 then version has a revision number that must be handled
        if (str.length > 4) {
            if (str.length === 5) {
                str = '0' + str;
            }
            version = version + str.substring(str.length - 6, (str.length - 6) + 2) + '.';
        }

        version = version + str.substring(str.length - 4, (str.length - 4) + 2) + '.' + str.substring(str.length - 2, str.length);

        return version.replace('v0', 'v');
    };
}
